<template>
    <div class="container col-sm-12 col-xs-12">
    <h3> <strong> {{email}}</strong></h3>
    <div v-if="codeSent">
     <div class="alert alert-danger" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      
      <div class="alert alert-info" v-if="alertMsg">
        <p> {{alertMsg}}</p>
      </div>
      </div>

     <div v-if="!codeSent">
        <div  class="alert alert-info">
          <p>We will generate a 6 digit code and send it to your registered email, press Generate Code when you are ready</p>
        </div>
            <button class="btn btn-success" @click="sendCode()">Generate Code</button>
       <div>
        </div>
        </div>

        <div class="form-group"  v-if="pending">
            <div v-if="codeSent">
            <div class="col-xs-6 remove-margins">
            <input v-if="pending" type="text" class="form-control" placeholder="Verification Code" v-model="code" maxlength="6" autocorrect="off" autocomplete="off" autocapitalize="off" spellcheck="false"></input> 
            </div>
            <div  class="col-xs-6">
                <button style="font-size:small !important;" :disabled="count>0" class="btn btn-info" v-if="pending" @click="sendCode()">Re-Send Code {{count}} </button>
            </div>
            </div>
            <br>
            <br>
            <div class="pull-right">
            <button class="btn btn-default" @click="closeEmail()">Close</button>
            </div>
        
    </div>   
    <button class="btn btn-default pull-right" v-if="!pending" @click="closeEmail()">Close</button>
       
    </div>
    
    
    
</template>


<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  
  
  export default {
    name: 'VerifyEmail',
    data() {
      return {  
        code: '',
        error: '',
        alert: 'Please check your email and enter the 6 digits verification code below:',
        pending: true,
        codeSent: false,
        count: '',
    }
    },
    methods: {
      closeEmail(){
        $('#verifyEmail').modal('hide')
      },
      startCountDown(){
          var self = this
          self.count=60
          var timer = setInterval(function (){
              self.count--
              if (self.count==0)
              {
                  self.count = ''
                   clearInterval(timer);
                   
              }
          }, 1000)
      },
      sendCode(){
          var self = this
          self.codeSent = true
          $.ajax({
            type: 'GET',
            url: 'https://www.dupaws.com/services/api/account/SendEmailCode',
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                    self.alert = "Code sent, check your email (ensure to check spam folder)."
                    self.startCountDown()

            },
            error:function(){
            try {
                    self.error = "Code sending Failed, try again.."
                    self.codeSent = false
            } catch(e)
            {
                self.codeSent = false
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      },
      initVerify(){
           var check = localStorage.getItem('emailConfirmed')
            if (check == "True"){
                this.pending = false
                this.codeSent = true
                this.alert = 'Has been verified, thank you.'
            }
      },
      verifyCode() {
          self = this
        $.ajax({
            type: 'POST',
            url: 'https://www.dupaws.com/services/api/account/ConfirmEmail?code=' + this.code,
            beforeSend: function(xhr){
                    xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
            },
            success: function (data) {
                localStorage.setItem('emailConfirmed', 'True')
                self.initVerify()
            },
            error:function(){
            try {
                self.error = "Verification Failed, try again.."
            } catch(e)
            {
                self.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      }
    },
    mounted: function() {
            this.initVerify()
            
    },
    watch:{
        'code': function(){
            if (this.code.length < 6)
            {
                this.error = ''
                return false
            }
            else if (this.code.length==6)
            {
                this.verifyCode()
            }
        },
    },
    computed: {
       
       errorMsg: function(){
           return this.error
       },
       alertMsg: function(){
           return this.alert
       },
     email: function(){
         return localStorage.getItem('email')
       }
    
  }
  
  }

</script>


<style scoped>
 
</style>


// WEBPACK FOOTER //
// VerifyEmail.vue?d9ea3214